module.exports = __webpack_public_path__ + "img/map4.9d4c2b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/map4.png
// module id = ./assets/loading/imgs/map4.png
// module chunks = 2 3 4 5 6 7 8